export default __webpack_public_path__ + "static/media/emblem1S.55d632e6.png";